var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4691_3459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09742 11.7351C1.18818 12.5391 1.54863 13.2886 2.12001 13.8614C2.69138 14.4343 3.43997 14.7966 4.24371 14.8894C5.46656 15.0266 6.72028 15.1431 8.00028 15.1431C9.28028 15.1431 10.5351 15.0266 11.7568 14.8894C12.5606 14.7966 13.3092 14.4343 13.8805 13.8614C14.4519 13.2886 14.8124 12.5391 14.9031 11.7351C15.0334 10.5203 15.1431 9.27228 15.1431 8.00028C15.1431 6.72828 15.0334 5.48028 14.9031 4.26428C14.8124 3.46031 14.4519 2.7108 13.8805 2.13798C13.3092 1.56515 12.5606 1.20279 11.7568 1.10999C10.534 0.975136 9.28028 0.857422 8.00028 0.857422C6.72028 0.857422 5.46542 0.973993 4.24371 1.11114C3.43997 1.20393 2.69138 1.56629 2.12001 2.13912C1.54863 2.71195 1.18818 3.46145 1.09742 4.26542C0.967136 5.47914 0.857422 6.72714 0.857422 8.00028C0.857422 9.27342 0.967136 10.5203 1.09742 11.7351Z",
    stroke: "#F48220",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.14258V10.8569",
    stroke: "#F48220",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8578 8H5.14355",
    stroke: "#F48220",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4691_3459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewIcon);
export default __webpack_public_path__ + "static/media/add-new-icon.6bdeae925d9a9e758f324fe4e10df746.svg";
export { ForwardRef as ReactComponent };